module.exports = __webpack_public_path__ + "dfb3e74663b01a47bb7d2bb58b18866f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/sheet.png
// module id = wP1L
// module chunks = 0